<template>
  <div id="app" class="app-main">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  .app-main {
      width: 100%;
      height: 100%;
    }

    .ant-table-header{
      background: transparent !important;
    }

    .ant-table-thead > tr >th{
        color: #4B76A0 !important;
        background: rgba(12, 19, 44, 0.5) !important;
        border: 0 !important;
    }

    .ant-table-tbody > tr > td {
      background: rgba(255,255,255,0) !important;
      border: 0 !important;
    }
    .ant-table-tbody > tr >td:hover{
      background: rgba(255,255,255,0) !important;
    }

    .light-row{
      background: #0E223F !important;
      color: white !important;
    }

    .dark-row{
      background:#0C132C !important;
      color: white !important;
    }

    /*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
    ::-webkit-scrollbar {
      width: 8px;
      height: 8px;
      background-color: #f5f5f5;
    }

    /*定义滚动条轨道 内阴影+圆角*/
    ::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      border-radius: 10px;
      background-color: transparent !important;
    }

    ::-webkit-scrollbar-track-piece {
      background: transparent !important;
    }

    /*定义滑块 内阴影+圆角*/
    ::-webkit-scrollbar-thumb {
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      background-color: #0C132C !important;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue